import { FunnelDashboard } from "@/components/admin/FunnelDashboard";

export default function AdminMaternityFunnel() {
  return (
    <FunnelDashboard
      campaign="maternity_outfit_guide"
      title="Maternity Guide Funnel"
      steps={[
        { key: "maternity_cta_click", label: "CTA click", color: "hsl(var(--primary))" },
        { key: "checkout_initiated", label: "Initiated", color: "#7dd3fc" },
        { key: "checkout_completed", label: "Completed", color: "#a3e635" },
      ]}
    />
  );
}
